import { combineReducers } from 'redux';
import { model, loading, error, FETCH_MODEL, RESET } from './ducks/get-model';

export const pageModel = combineReducers({ model, loading, error });
export const pageModelActions = { FETCH_MODEL, RESET };

export { getSeoTextHTML } from './ducks/get-model';

export * from 'features/page-model/types';
export * from 'features/page-model/selectors';
